// The Vue build version to load with the `import` command
import 'core-js/es6/promise'
import 'core-js/es6/string'
import 'core-js/es7/array'
// import cssVars from 'css-vars-ponyfill'
import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import App from './App'
import { router } from '@/router'
import {i18n} from '@/_plugins/i18n';
import VueKonva from 'vue-konva';
import { applyMenuVisibility } from '@/_helpers';
 
Vue.use(BootstrapVue);
Vue.use(VueKonva);

applyMenuVisibility(router.currentRoute);
router.afterEach((to) => {
  applyMenuVisibility(to);
});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  i18n,
  template: '<App/>',
  components: {
    App
  }
});
